import {useCallback, useState} from "react";

export default function useInput(initValue='')
:[string, (e:React.ChangeEvent<HTMLInputElement>) => void, React.Dispatch<React.SetStateAction<string>>]
{
  const [value, setValue] = useState(initValue);
  const handleValue = useCallback((e:React.ChangeEvent<HTMLInputElement>) => {
      setValue(e.target.value);
  }, []);

  return [
    value,
    handleValue,
    setValue
  ]
}